import BaseModelAPI from '../BaseModelAPI';

export default class ReportIncoming extends BaseModelAPI {
	static entity = 'newreport1999';
	static entityName = 'reportincoming';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterSupplier = '';
		this.filterPart = '';
		this.filterPurchaseOrderNumber = '';
		this.filterPartGoodReceiptDate = '';
		this.filterCustomer = '';
		this.filterPartSpecification = '';
		this.tempId = 0;
		this.grDate = '';
		this.suratJalan = '';
		this.purchaseOrderNumber = '';
		this.partNumber = '';
		this.partSpecification = '';
		this.qtyActual = 0;
		this.uom = '';
		this.customerCode = '';
		this.supplierCode = '';
		this.supplierCaseNumber = '';
		this.caseNumber = '';
		this.remark = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async getSum(this_, filter, sorting) {
		let filterArray = Array();
		if (filter != null && filter != undefined) {
			filterArray = this.getFilter(filter);
		}
		if (sorting != null && sorting != undefined) {
			Object.entries(sorting).map(([key, value]) => {
				if (key != '') {
					filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
				}
			});

		}
		let params = "";
		if (filterArray.length > 0) {
			params = "?" + filterArray.join("&");
		}

		//DEBUG

		return this_.$http.get(`${this.entityName}/getsum` + params)
			.then(response => {
				if (response != null) {
					return response.data;
				}
				return response;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}